module.exports = __webpack_public_path__ + "static/media/physicsIcon.53fedc23.svg";